import axios from 'axios';
import i18n from '../i18n';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add JWT token and the active UI language
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers['Accept-Language'] = i18n.language;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 and 429 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    if (error.response && error.response.status === 429) {
      window.dispatchEvent(new CustomEvent('rate-limit-exceeded'));
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  register: (username, email, password) =>
    api.post('/auth/register', { username, email, password }),

  login: (usernameOrEmail, password) =>
    api.post('/auth/login', { usernameOrEmail, password }),

  verifyEmail: (token) =>
    api.get(`/auth/verify?token=${token}`),

  resendVerification: (email) =>
    api.post(`/auth/resend-verification?email=${email}`),

  forgotPassword: (email) =>
    api.post(`/auth/forgot-password?email=${email}`),

  resetPassword: (token, newPassword) =>
    api.post('/auth/reset-password', { token, newPassword }),
};

// Todo API
export const todoAPI = {
  getAll: () => api.get('/todos'),
  
  create: (title, description, areaId, urgency, dueDate) =>
    api.post('/todos', { title, description, completed: false, areaId, urgency: urgency || null, dueDate: dueDate || null }),

  update: (id, title, description, completed, areaId, urgency, dueDate) =>
    api.put(`/todos/${id}`, { title, description, completed, areaId, urgency: urgency || null, dueDate: dueDate || null }),
  
  delete: (id) => api.delete(`/todos/${id}`),

  reorder: (orderedIds) => api.put('/todos/reorder', orderedIds),
};

// Area API
export const areaAPI = {
  getAll: () => api.get('/areas'),

  create: (name) => api.post('/areas', { name }),

  update: (id, name) => api.put(`/areas/${id}`, { name }),

  delete: (id) => api.delete(`/areas/${id}`),
};

// Admin API
export const adminAPI = {
  getUsers: () => api.get('/admin/users'),
};

export default api;
